import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { RequestError } from '@/shared/ui/RequestState';
import classes from './ImagePreviewDialog.module.scss';

interface ImagePreviewDialogProps {
    imageUrl: string | null;
    alt?: string;
    onClose: () => void;
}

/** Показывает изображение на весь экран с возвратом к открывшему элементу */
export const ImagePreviewDialog = (
    { imageUrl, alt = 'Изображение в полном размере', onClose }: ImagePreviewDialogProps
) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => { setFailed(false); }, [imageUrl]);

    return <Dialog
        visible={Boolean(imageUrl)}
        header="Просмотр изображения"
        onHide={onClose}
        maximized
        modal
        draggable={false}
        resizable={false}
        blockScroll
        className={classes.previewDialog}
        pt={{
            content: { className: classes.content },
            closeButton: { 'aria-label': 'Закрыть изображение' }
        }}
    >
        {failed
            ? <RequestError message="Не удалось открыть изображение" />
            : imageUrl && <img
                src={imageUrl}
                alt={alt}
                onError={() => setFailed(true)}
            />}
    </Dialog>;
};
